import type { PlayerProfileResponse, RpmPicks } from '@on3/api';
import { On3IconFlippedPrediction } from '@on3/icons';
import { useAuth } from '@on3/ui-lib/contexts/AuthProvider';
import { databaseUrl } from '@on3/ui-lib/utils/api';
import { TextLink } from '@public/components/UI/Link/TextLink';
import { Text } from '@public/components/UI/Typography/Text';

import styles from './InsiderPredictions.module.scss';
import { InsiderPredictionsItem } from './InsiderPreditctionsItem';

interface IInsiderPredictionsProps {
  picks?: RpmPicks[];
  basicInfo?: PlayerProfileResponse;
}
export const InsiderPredictions = ({
  picks,
  basicInfo,
}: IInsiderPredictionsProps) => {
  const { hasRdbAccess } = useAuth();

  return (
    <section className={styles.insiderPredictionsWrapper}>
      <header className={styles.predictionsHeader}>
        <Text
          className={styles.headerInfoText}
          component="h5"
          variant="overline"
        >
          Predictions from Recruiting Insiders
        </Text>
        {hasRdbAccess() && (
          <TextLink
            className={styles.adminLink}
            href={`${databaseUrl}/people/${basicInfo?.slug}/recruiting/${basicInfo?.recruitmentKey}/edit/#make-a-prediction`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Make a Prediction
          </TextLink>
        )}
        <div className={styles.headerTextContainer}>
          <Text className={styles.listHeader} variant="h6">
            Predictions
          </Text>

          <Text className={styles.headerText} variant="h6">
            Expert
          </Text>
          <Text className={styles.headerText} variant="h6">
            Confidence
          </Text>
        </div>
      </header>
      {picks?.length ? (
        <ul className={styles.predictionListWrapper}>
          {picks?.map((pick) => (
            <InsiderPredictionsItem
              {...pick}
              key={pick.key}
              sport={basicInfo?.defaultSport?.name}
              year={basicInfo?.classYear || 0}
            />
          ))}
        </ul>
      ) : (
        <Text className={styles.noPredictionsText} variant="overline">
          No Predictions Made
        </Text>
      )}
      <div className={styles.legendContainer}>
        <On3IconFlippedPrediction className={styles.legendIcon} />
        <Text className={styles.legendText} variant="caption">
          Flipped prediction
        </Text>
      </div>
    </section>
  );
};
